import { render, staticRenderFns } from "./previewDialog.vue?vue&type=template&id=48f99cc0&scoped=true&"
import script from "./previewDialog.vue?vue&type=script&lang=js&"
export * from "./previewDialog.vue?vue&type=script&lang=js&"
import style0 from "./previewDialog.vue?vue&type=style&index=0&id=48f99cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f99cc0",
  null
  
)

export default component.exports